export const Accordion = new function() {
  let accordions;
  let headers;
  let toggles;

  this.init = () => {
    this.accordions = gsap.utils.toArray('.sn-accordion');
    this.headers = gsap.utils.toArray('.sn-accordion__header');
    this.toggles = this.accordions.map(this.createToggle);

    this.headers.forEach(header => {
      header.addEventListener("click", () => this.toggle(header));
    });
  },

  this.toggle = (clickedHeader) => {
    this.toggles.forEach(toggle => toggle(clickedHeader));
  },

  this.createToggle = (element) => {
    const header = element.querySelector(".sn-accordion__header");
    const body = element.querySelector(".sn-accordion__body");
    const content = element.querySelector(".sn-accordion__cnt");
    const icon = element.querySelector(".sn-icon");

    gsap.set(body, { height: "auto" });

    const tl = gsap.timeline({ paused: true });

    tl.to(body, {
      height: 0,
      duration: 0.3,
      ease: "power1.inOut"
    })
      .set(body, { height: "auto" })
      .from(body, {
        height: 0,
        duration: 0.3,
        ease: "power1.inOut"
      })
      .fromTo(content, {
        opacity: 0
      }, {
        opacity: 1,
        duration: 0.25
      })
      .to(icon, {
        rotation: "180deg",
        duration: 0.35
      });

    const toggle = tl.reverse();

    return function (clickedHeader) {
      if (clickedHeader === header) {
        toggle.reversed(!toggle.reversed());
      } else {
        toggle.reverse();
      }
    }
  }
};